import {
  ROLES,
  DEPOSIT_ACCESS,
  INITIATOR_ACCESS,
  APPROVER_ACCESS,
  APPROVER_WITH_TRANSACTION_LIMIT,
  ADMIN_BUSINESS_NAME
} from '@/utils/constants'

export default {
  data () {
    return {
      roles: ROLES,
      depositAccess: DEPOSIT_ACCESS,
      initiators: INITIATOR_ACCESS,
      approvers: APPROVER_ACCESS,
      approversWithLimit: APPROVER_WITH_TRANSACTION_LIMIT
    }
  },
  computed: {
    currentUser () {
      return this.$store.state?.auth?.user?.kind
    },
    currentUserKind () {
      return this.roles.find((role) => role.value === this.currentUser)
    },
    currentUserRole () {
      return this.roles.find((role) => role.value === this.currentUser)?.label
    },
    isUserKindOwner () {
      const owner = this.roles.find((role) => role.label === 'owner')
      return this.currentUser === owner.value
    },
    isUserKindAdmin () {
      const admin = this.roles.find((role) => role.label === 'admin')
      return this.currentUser === admin.value
    },
    hasInitiatorAccess () {
      return this.initiators.includes(this.currentUserRole)
    },
    hasApproverAccess () {
      return this.approvers.includes(this.currentUserRole)
    },
    hasDepositAccess () {
      return this.depositAccess.includes(this.currentUser)
    },
    isUserKindViewOnly () {
      const viewOnly = this.roles.find((item) => item.label === 'view_only')
      return this.currentUser === viewOnly.value
    },
    isUserKindDeveloper () {
      const developerAccess = this.roles.find(
        (item) => item.label === 'developer_access'
      )
      return this.currentUser === developerAccess.value
    },
    hasTransactionLimit () {
      const transactionLimit = this.$store.state.auth.user.transactionLimit
      const approverWithLimit = this.approversWithLimit.includes(
        this.currentUserRole
      )
      const usersLimit = transactionLimit ? parseFloat(transactionLimit) : null

      return approverWithLimit && usersLimit > 0 ? usersLimit : null
    },
    exRate () {
      return this.$store?.state?.auth.transferDetails
    },
    businessName () {
      return this.$store?.state?.auth.business.name
    },
    adminBusinessName () {
      return localStorage.getItem(ADMIN_BUSINESS_NAME) || ''
    },
    canManageIPAddresses () {
      return this.isUserKindOwner || this.isUserKindAdmin
    }
  },
  methods: {
    userStatus (type) {
      let style
      if (type === 'active') {
        style = 'bg-foreground border-border-color'
      } else if (type === 'pending') {
        style = 'bg-yellow-8 border-border-color'
      } else {
        style = 'bg-none border-none'
      }

      return style
    }
  }
}
